import { MatDialog } from '@angular/material';
import { DialogLinkEquipmentComponent } from './dialog-link-equipment.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/dialog";
var LinkEquipmentDialogService = /** @class */ (function () {
    function LinkEquipmentDialogService(matDialog) {
        this.matDialog = matDialog;
    }
    LinkEquipmentDialogService.prototype.open = function (_a) {
        var locationEnvironmentId = _a.locationEnvironmentId, locationId = _a.locationId, locationSectorId = _a.locationSectorId;
        return this.matDialog.open(DialogLinkEquipmentComponent, {
            panelClass: 'dialog-link-equipment',
            autoFocus: false,
            data: {
                locationEnvironmentId: locationEnvironmentId,
                locationId: locationId,
                locationSectorId: locationSectorId
            }
        }).afterClosed()
            .toPromise();
    };
    LinkEquipmentDialogService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LinkEquipmentDialogService_Factory() { return new LinkEquipmentDialogService(i0.ɵɵinject(i1.MatDialog)); }, token: LinkEquipmentDialogService, providedIn: "root" });
    return LinkEquipmentDialogService;
}());
export { LinkEquipmentDialogService };
